"use client";

import dynamic from "next/dynamic";
import Link from "next/link";

const WalletConnect = dynamic(
  () => import("@/components/wallet/WalletConnect").then(mod => mod.ClientWalletConnect),
  { ssr: false }
);

export default function Home() {
  return (
    <main className="min-h-screen bg-[#0a0a0a] text-gray-100 flex flex-col items-center justify-center">
      {/* Hero Section */}
      <section className="w-full flex flex-col items-center justify-center text-center py-24 px-4 relative">
        <div className="absolute inset-0 pointer-events-none z-0">
          <div className="w-full h-full bg-gradient-to-br from-purple-900/40 via-indigo-900/30 to-black/80 blur-2xl"></div>
        </div>
        <h1 className="relative z-10 text-5xl md:text-6xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-6 drop-shadow-lg">Khám phá thế giới vé NFT</h1>
        <p className="relative z-10 max-w-2xl text-lg md:text-xl text-purple-200 mb-8">Sở hữu vé sự kiện độc quyền dưới dạng NFT - An toàn, minh bạch và có thể giao dịch. Trải nghiệm các sự kiện đặc biệt như chưa từng có!</p>
        <div className="relative z-10 flex flex-col sm:flex-row gap-4 justify-center items-center mb-6">
          <Link href="/xoso">
            <button className="px-8 py-3 rounded-full font-bold bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow-lg hover:scale-105 transition">Mua vé NFT</button>
          </Link>
          <Link href="/events">
            <button className="px-8 py-3 rounded-full font-bold bg-gradient-to-r from-purple-500 to-pink-600 text-white shadow-lg hover:scale-105 transition">Xem sự kiện</button>
          </Link>
          <Link href="/event/create">
            <button className="px-8 py-3 rounded-full font-bold border-2 border-purple-400 text-purple-200 bg-transparent hover:bg-purple-900/20 transition">Tạo sự kiện</button>
          </Link>
        </div>
        <div className="relative z-10 flex justify-center">
          <WalletConnect />
        </div>
      </section>

      {/* Stats Section */}
      <section className="w-full max-w-5xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-6 py-12">
        <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 text-center shadow-lg">
          <div className="text-3xl md:text-4xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-2">120K+</div>
          <div className="text-purple-200 text-lg">Người dùng</div>
        </div>
        <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 text-center shadow-lg">
          <div className="text-3xl md:text-4xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-2">85K+</div>
          <div className="text-purple-200 text-lg">Vé NFT đã bán</div>
        </div>
        <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 text-center shadow-lg">
          <div className="text-3xl md:text-4xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-2">1.2M+</div>
          <div className="text-purple-200 text-lg">Giao dịch</div>
        </div>
        <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 text-center shadow-lg">
          <div className="text-3xl md:text-4xl font-extrabold bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-2">350+</div>
          <div className="text-purple-200 text-lg">Sự kiện NFT</div>
        </div>
      </section>

      {/* Featured Tickets Section */}
      <section className="w-full max-w-6xl mx-auto py-12 px-4">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-4">Vé NFT Độc Quyền</h2>
        <p className="text-center text-purple-200 mb-8">Sở hữu vé sự kiện dưới dạng NFT - không chỉ là tấm vé, mà còn là tài sản kỹ thuật số có thể giao dịch và sưu tầm</p>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Demo ticket cards */}
          <div className="rounded-2xl bg-gradient-to-br from-pink-500/80 to-purple-700/80 p-6 shadow-xl flex flex-col items-center">
            <div className="text-lg font-bold mb-2">VIP</div>
            <div className="text-2xl font-extrabold mb-1">BLACKPINK</div>
            <div className="text-purple-100 mb-2">WORLD TOUR [BORN PINK]</div>
            <div className="text-purple-200 text-sm mb-2">Hà Nội | 29/07/2023</div>
            <div className="text-purple-200 text-sm mb-4">Khu vực: A1 | Ghế: VIP12</div>
            <div className="font-bold text-xl mb-2">1.8 ETH</div>
            <button className="px-6 py-2 rounded-full font-bold bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow hover:scale-105 transition">Mua ngay</button>
          </div>
          <div className="rounded-2xl bg-gradient-to-br from-blue-700/80 to-indigo-900/80 p-6 shadow-xl flex flex-col items-center">
            <div className="text-lg font-bold mb-2">ĐẶC BIỆT</div>
            <div className="text-2xl font-extrabold mb-1">WORLD CUP 2026</div>
            <div className="text-purple-100 mb-2">FIFA World Cup Final</div>
            <div className="text-purple-200 text-sm mb-2">New York | 19/07/2026</div>
            <div className="text-purple-200 text-sm mb-4">Khu vực: Trung tâm | Ghế: A23</div>
            <div className="font-bold text-xl mb-2">3.5 ETH</div>
            <button className="px-6 py-2 rounded-full font-bold bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow hover:scale-105 transition">Mua ngay</button>
          </div>
          <div className="rounded-2xl bg-gradient-to-br from-green-500/80 to-blue-700/80 p-6 shadow-xl flex flex-col items-center">
            <div className="text-lg font-bold mb-2">GOLD</div>
            <div className="text-2xl font-extrabold mb-1">HIẾU THỨ 2</div>
            <div className="text-purple-100 mb-2">CÀ PHÊ CHỦ NHẬT TOUR</div>
            <div className="text-purple-200 text-sm mb-2">TP.HCM | 15/12/2024</div>
            <div className="text-purple-200 text-sm mb-4">Khu vực: Gold | Ghế: G08</div>
            <div className="font-bold text-xl mb-2">0.9 ETH</div>
            <button className="px-6 py-2 rounded-full font-bold bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow hover:scale-105 transition">Mua ngay</button>
          </div>
          <div className="rounded-2xl bg-gradient-to-br from-yellow-400/80 to-red-500/80 p-6 shadow-xl flex flex-col items-center">
            <div className="text-lg font-bold mb-2">PLATINUM</div>
            <div className="text-2xl font-extrabold mb-1">SƠN TÙNG M-TP</div>
            <div className="text-purple-100 mb-2">SKY TOUR FINAL</div>
            <div className="text-purple-200 text-sm mb-2">Hà Nội | 20/01/2025</div>
            <div className="text-purple-200 text-sm mb-4">Khu vực: Platinum | Ghế: P05</div>
            <div className="font-bold text-xl mb-2">1.2 ETH</div>
            <button className="px-6 py-2 rounded-full font-bold bg-gradient-to-r from-blue-500 to-purple-600 text-white shadow hover:scale-105 transition">Mua ngay</button>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="w-full max-w-6xl mx-auto py-12 px-4">
        <h2 className="text-3xl md:text-4xl font-extrabold text-center bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 mb-8">Tính năng chính</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 shadow flex flex-col items-center">
            <div className="text-3xl mb-2">🎫</div>
            <div className="font-bold text-xl mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">Vé NFT Sự kiện</div>
            <div className="text-purple-200 text-center">Sở hữu vé sự kiện dưới dạng NFT độc đáo, có thể chuyển nhượng và sưu tầm.</div>
          </div>
          <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 shadow flex flex-col items-center">
            <div className="text-3xl mb-2">🔨</div>
            <div className="font-bold text-xl mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">Đấu giá NFT</div>
            <div className="text-purple-200 text-center">Tham gia đấu giá các vé NFT độc quyền, sưu tập nghệ thuật số hiếm.</div>
          </div>
          <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 shadow flex flex-col items-center">
            <div className="text-3xl mb-2">👛</div>
            <div className="font-bold text-xl mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">Ví đa chuỗi</div>
            <div className="text-purple-200 text-center">Lưu trữ, quản lý NFT, giao dịch dễ dàng, hỗ trợ nhiều blockchain.</div>
          </div>
          <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 shadow flex flex-col items-center">
            <div className="text-3xl mb-2">➕</div>
            <div className="font-bold text-xl mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">Tạo vé NFT</div>
            <div className="text-purple-200 text-center">Dễ dàng tạo và phân phối vé NFT cho sự kiện của bạn.</div>
          </div>
          <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 shadow flex flex-col items-center">
            <div className="text-3xl mb-2">🛡️</div>
            <div className="font-bold text-xl mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">Bảo mật & Xác thực</div>
            <div className="text-purple-200 text-center">Blockchain đảm bảo tính xác thực và chống gian lận.</div>
          </div>
          <div className="rounded-2xl bg-[rgba(255,255,255,0.05)] border border-purple-800 p-8 shadow flex flex-col items-center">
            <div className="text-3xl mb-2">📈</div>
            <div className="font-bold text-xl mb-2 bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400">Thị trường thứ cấp</div>
            <div className="text-purple-200 text-center">Giao dịch vé NFT dễ dàng, minh bạch, theo dõi giá cả và lịch sử.</div>
          </div>
        </div>
      </section>
    </main>
  );
}